import React, { useState } from "react";

import ServiceApi from "../services/service.api";
import ContextApp from "../contexts/context.app";
 import BasketStorage from "../../app/pages/Basket/Component/BasketStorage";
import ServiceStorage from "../services/service.storage";
import _ from "lodash";

function ProviderApp({ children }) {
  const [isAuth, setIsAuthState] = useState(ServiceApi.hasToken());
  // const [userInfo, setUserInfo] = useState(ServiceStorage.getUserInfo());//{name:"",phone:""}
   const [basketInfo, setbasketInfo] = useState(BasketStorage.getBasket());
  const [basketPersonInfo, setbasketPersonInfo] = useState(BasketStorage.getBasketPerson());
  // const [lastUpdate, setLastUpdate] = useState();
  const [selectedCity, setSelectedCity] = useState(() => {
    return !_.isNil(ServiceStorage.getSelectedCity())
      ? ServiceStorage.getSelectedCity()
      : null;
  });
  const setIsAuth = (value) => {
    if (value) {
      ServiceApi.setToken();
    } else {
      ServiceApi.logout();
    }
    setIsAuthState(value);
  };

  const ctxApp = {
    isAuth,
    setIsAuth,
    selectedCity,
    setSelectedCity,
    // userInfo,
    // setUserInfo,
     basketInfo,
     setbasketInfo,
     basketPersonInfo,
    setbasketPersonInfo,
    // lastUpdate,
    // setLastUpdate
  };

  return <ContextApp.Provider value={ctxApp}>{children}</ContextApp.Provider>;
}

export default ProviderApp;
